"use strict";

exports.__esModule = true;
exports.themePriority = exports.themePriorities = void 0;
var themePriority = exports.themePriority = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  TRIVIAL: 'trivial',
  LOW_ICON: 'lowIcon'
};
var themePriorities = exports.themePriorities = Object.values(themePriority);